import React, {useEffect, useState} from "react";
import {
    FormControl,
    Input,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    withStyles
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import clsx from 'clsx';

const styles = theme => ({
    formControl: {
        width: '100%'
    }
});

const WifiForm = (props) => {
    const { classes, translations, formikProps, index } = props;

    const {values, handleBlur, errors, touched, setFieldValue, handleChange} = formikProps;

    const [passwordVisible, setPasswordVisible] = useState(false);

    const usernameRequiredFor = ["wpa_enterprise", "wpa2_enterprise", "wpa3_enterprise"];

    const [usernameRequired, setUsernameRequired] = useState(false);

    useEffect(() => {
        setUsernameRequired(usernameRequiredFor.includes(values.Wifis[index]?.Security));
    }, [index, usernameRequiredFor, values.Wifis]);

    const options = [
        {value: "wep", displayValue: "WEP"},
        {value: "wpa", displayValue: "WPA"},
        {value: "wpa2_wpa3", displayValue: "WPA2/WPA3"},
        {value: "wpa3", displayValue: "WPA3"},
        // {value: "wpa_enterprise", displayValue: "WPA Enterprise"},
        // {value: "wpa2_enterprise", displayValue: "WPA2 Enterprise"},
        // {value: "wpa3_enterprise", displayValue: "WPA3 Enterprise"}
    ];

    const handleClickShowPassword = () => {
        setPasswordVisible(prevState => !prevState);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSecurityChange = (e) => {
        const securityValue = e.target.value;
        if (usernameRequiredFor.includes(securityValue)) {
            setFieldValue(`Wifis[${index}]`, {Security: securityValue, SSID: values.Wifis[index].SSID, Password: values.Wifis[index].Password, Username: values.Wifis[index].Username || null});
            setUsernameRequired(true);
        } else {
            setFieldValue(`Wifis[${index}]`, {Security: securityValue, SSID: values.Wifis[index].SSID, Password: values.Wifis[index].Password, Username: "",});
            setUsernameRequired(false);
        }
    }

    const inputProps = {
        autoComplete: 'new-password',
            form: {
            autoComplete: 'off',
            },
        }

    return (
        <>
            <FormControl className={classes.formControl} margin={'dense'}>
                <InputLabel shrink>{translations['security'] || 'Security'}</InputLabel>
                <Select name={`Wifis[${index}].Security`} margin={'dense'} value={values.Wifis[index]?.Security || ''} 
                        onChange={handleSecurityChange}>
                    {(options ? [...options] : []).map(option => (
                        <MenuItem key={option.value} value={option.value || ''}>
                            {option.displayValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <TextField
                name={`Wifis[${index}].SSID`}
                value={values.Wifis[index]?.SSID || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!(errors.SSID && touched.SSID && errors.SSID)}
                placeholder={translations['ssid_label'] || 'WiFi name / SSID'}
                label={translations['ssid_label'] || 'WiFi name / SSID'}
                margin={'dense'}
                fullWidth={true}
                type="text"
                inputProps={inputProps}
            />
            <FormControl className={clsx(classes.margin, classes.formControl)}>
                <InputLabel htmlFor={`Wifis[${index}].Password`}>{translations['password'] || 'Password'}</InputLabel>
                <Input
                    type={passwordVisible ? 'text' : 'password'}
                    name={`Wifis[${index}].Password`}
                    value={values.Wifis[index]?.Password || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.Password && touched.Password && errors.Password)}
                    placeholder={translations['password'] || 'Password'}
                    label={translations['password'] || 'Password'}
                    fullWidth={true}
                    inputProps={inputProps}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                            >
                                {passwordVisible ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
            {usernameRequired &&
                <TextField
                    name={`Wifis[${index}].Username`}
                    value={values.Wifis[index]?.Username || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.Username && touched.Username && errors.Username)}
                    placeholder={translations['username'] || 'Username'}
                    label={translations['username'] || 'Username'}
                    margin={'dense'}
                    fullWidth={true}
                    type="text"
                    inputProps={inputProps}
                />}
        </>
    )
}

export default withStyles(styles, { withTheme: true })(WifiForm);
